import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const AdminPostEditor = ({ form, editing, loading, setField, onSubmit, onCancel }) => (
  <form
    onSubmit={onSubmit}
    data-testid="admin-post-form"
    className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 sm:p-8"
  >
    <h2 className="text-lg font-extrabold text-slate-900">{editing ? "Edit post" : "New post"}</h2>
    <div className="mt-4 grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <Label className="text-xs font-semibold text-slate-700">Title *</Label>
        <Input
          data-testid="admin-post-title"
          value={form.title}
          onChange={(e) => setField("title", e.target.value)}
          className="mt-1 h-11 rounded-lg border-slate-200"
        />
      </div>
      <div className="sm:col-span-2">
        <Label className="text-xs font-semibold text-slate-700">Excerpt *</Label>
        <Input
          data-testid="admin-post-excerpt"
          value={form.excerpt}
          onChange={(e) => setField("excerpt", e.target.value)}
          className="mt-1 h-11 rounded-lg border-slate-200"
        />
      </div>
      <div>
        <Label className="text-xs font-semibold text-slate-700">Category</Label>
        <Input
          data-testid="admin-post-category"
          value={form.category || ""}
          onChange={(e) => setField("category", e.target.value)}
          className="mt-1 h-11 rounded-lg border-slate-200"
        />
      </div>
      <div>
        <Label className="text-xs font-semibold text-slate-700">Author</Label>
        <Input
          data-testid="admin-post-author"
          value={form.author || ""}
          onChange={(e) => setField("author", e.target.value)}
          className="mt-1 h-11 rounded-lg border-slate-200"
        />
      </div>
      <div>
        <Label className="text-xs font-semibold text-slate-700">Cover image URL</Label>
        <Input
          data-testid="admin-post-cover"
          value={form.cover_image || ""}
          onChange={(e) => setField("cover_image", e.target.value)}
          placeholder="https://…"
          className="mt-1 h-11 rounded-lg border-slate-200"
        />
      </div>
      <div>
        <Label className="text-xs font-semibold text-slate-700">Locale</Label>
        <select
          data-testid="admin-post-locale"
          value={form.locale}
          onChange={(e) => setField("locale", e.target.value)}
          className="mt-1 h-11 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm"
        >
          <option value="en">English (en)</option>
          <option value="zh">中文 (zh)</option>
          <option value="ja">日本語 (ja)</option>
          <option value="vi">Tiếng Việt (vi)</option>
          <option value="ko">한국어 (ko)</option>
          <option value="fr">Français (fr)</option>
          <option value="de">Deutsch (de)</option>
        </select>
      </div>
      <div className="sm:col-span-2">
        <Label className="text-xs font-semibold text-slate-700">Content (markdown / text) *</Label>
        <Textarea
          data-testid="admin-post-content"
          rows={10}
          value={form.content}
          onChange={(e) => setField("content", e.target.value)}
          className="mt-1 rounded-lg border-slate-200"
        />
      </div>
      <div className="flex items-center gap-2 sm:col-span-2">
        <input
          id="published"
          type="checkbox"
          checked={!!form.published}
          onChange={(e) => setField("published", e.target.checked)}
          data-testid="admin-post-published"
        />
        <Label htmlFor="published" className="text-sm text-slate-700">Published</Label>
      </div>
    </div>
    <div className="mt-6 flex flex-wrap gap-2">
      <Button
        type="submit"
        disabled={loading}
        data-testid="admin-post-save-button"
        className="h-11 rounded-lg bg-blue-600 px-5 text-white hover:bg-blue-700"
      >
        <Plus className="mr-1.5 h-4 w-4" /> {editing ? "Save changes" : "Create post"}
      </Button>
      {editing && (
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          className="h-11 rounded-lg border-slate-300 bg-white"
        >
          Cancel
        </Button>
      )}
    </div>
  </form>
);
